import { Button, Switch } from 'antd';
import { useState } from 'react';
import ModalConfirm from '../components/Shared/modal/confirm';
import ModalFail from '../components/Shared/modal/fail';
import ModalSave from '../components/Shared/modal/save';
import ModalStop from '../components/Shared/modal/stop';
import ModalSuccess from '../components/Shared/modal/success';
import ModalDelete from '../components/Shared/modal/delete';
import ModalStatus from '../components/Shared/modal/status';
import Modal500 from '../components/Shared/modal/error500';

const ModalPage = () => {
    const [openFail, setOpenFail] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openStop, setOpenStop] = useState(false);
    const [openConfirmClose, setOpenConfirmClose] = useState(false);
    const [openStopClose, setOpenStopClose] = useState(false);
    const [openSave, setOpenSave] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openOn, setOpenOn] = useState(false);
    const [openOff, setOpenOff] = useState(false);
    const [open500, setOpen500] = useState(false);
    const [loading, setLoading] = useState(false);

    return (
        <div className="space-y-6 ">
            <div className="title">Modal Example</div>
            <div className="flex flex-col w-max space-y-6">
                <div>
                    Loading:{' '}
                    <Switch
                        checkedChildren="true"
                        unCheckedChildren="false"
                        checked={loading}
                        onChange={(checked) => setLoading(checked)}
                    />
                </div>
                <Button
                    type="primary"
                    onClick={() => setOpenFail(true)}
                    size="large"
                    danger
                >
                    Fail
                </Button>

                <Button
                    onClick={() => setOpenSuccess(true)}
                    size="large"
                    type="primary"
                >
                    Success
                </Button>
                <Button
                    onClick={() => setOpenConfirm(true)}
                    size="large"
                    type="primary"
                >
                    Confirm
                </Button>
                <Button
                    onClick={() => setOpenStop(true)}
                    size="large"
                    type="primary"
                >
                    Stop
                </Button>

                <Button
                    onClick={() => setOpenConfirmClose(true)}
                    size="large"
                    type="primary"
                >
                    Confirm Wish Close
                </Button>
                <Button
                    onClick={() => setOpenStopClose(true)}
                    size="large"
                    type="primary"
                >
                    Stop Wish Close
                </Button>
                <Button
                    onClick={() => setOpenSave(true)}
                    size="large"
                    type="primary"
                >
                    Save
                </Button>
                <Button
                    type="primary"
                    onClick={() => setOpenDelete(true)}
                    size="large"
                    danger
                >
                    Delete
                </Button>
                <Button
                    type="primary"
                    onClick={() => setOpenOn(true)}
                    size="large"
                >
                    On
                </Button>
                <Button
                    type="primary"
                    onClick={() => setOpenOff(true)}
                    size="large"
                    danger
                >
                    Off
                </Button>
                <Button
                    type="primary"
                    onClick={() => setOpen500(true)}
                    size="large"
                >
                    500
                </Button>
            </div>

            {/* Modal */}
            <ModalFail open={openFail} handelClose={() => setOpenFail(false)} />
            <ModalSuccess
                open={openSuccess}
                handelClose={() => setOpenSuccess(false)}
            />
            <ModalConfirm
                loading={loading}
                open={openConfirm}
                handelOk={() => setOpenConfirm(false)}
                handelClose={() => setOpenConfirm(false)}
            />
            <ModalStop
                loading={loading}
                open={openStop}
                handelOk={() => setOpenStop(false)}
                handelClose={() => setOpenStop(false)}
            />
            <ModalConfirm
                isConfirm={false}
                loading={loading}
                open={openConfirmClose}
                handelOk={() => setOpenConfirmClose(false)}
                handelClose={() => setOpenConfirmClose(false)}
            />
            <ModalStop
                isConfirm={false}
                loading={loading}
                open={openStopClose}
                handelOk={() => setOpenStopClose(false)}
                handelClose={() => setOpenStopClose(false)}
            />
            <ModalSave
                loading={loading}
                open={openSave}
                handelOk={() => setOpenSave(false)}
                handelClose={() => setOpenSave(false)}
            />
            <ModalDelete
                loading={loading}
                open={openDelete}
                handelOk={() => setOpenDelete(false)}
                handelClose={() => setOpenDelete(false)}
            />
            <ModalStatus
                loading={loading}
                open={openOff}
                handelOk={() => setOpenOff(false)}
                handelClose={() => setOpenOff(false)}
            />
            <ModalStatus
                on={false}
                loading={loading}
                open={openOn}
                handelOk={() => setOpenOn(false)}
                handelClose={() => setOpenOn(false)}
            />
            <Modal500
                open={open500}
                handelOk={() => setOpen500(false)}
                handelClose={() => setOpen500(false)}
            />
        </div>
    );
};

export default ModalPage;
